// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delete_header {
  padding: 20px 20px 0 20px;
  font-size: 20px;
  font-weight: 600;
  line-height: 25.2px;
  display: flex;
  align-self: flex-start;
}

.delete_subheader {
  padding: 8px 20px 4px 20px;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  display: flex;
  align-self: flex-start;
}
`, "",{"version":3,"sources":["webpack://./src/components/deletePopup/deletePopup.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB","sourcesContent":[".delete_header {\n  padding: 20px 20px 0 20px;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 25.2px;\n  display: flex;\n  align-self: flex-start;\n}\n\n.delete_subheader {\n  padding: 8px 20px 4px 20px;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 22px;\n  display: flex;\n  align-self: flex-start;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
